(ns dashboard.views.workbook-workspace.components.modal-save-extraction-results
  (:require [clojure.string :as str]
            [re-frame.core :as rf]
            [dashboard.services.http-config :as http-config]
            [dashboard.ui :as ui]
            [dashboard.notifications :as notifications]
            [dashboard.views.workbook-workspace.subs :as subs]))

(rf/reg-event-fx
  ::import-success
  (fn [{:keys [db]} [_ questionnaire sheet on-save]]
    (when (fn? on-save) (on-save))
    {:db (assoc-in db [:workbook-workspace :workbooks questionnaire sheet :parsing-config :questions-extracted] true)
     :dispatch [::notifications/add {:message "Imported questions"}]}))

(rf/reg-event-fx
  ::import-questions
  (fn [_ [_ questionnaire sheet parsing-config on-save]]
    {:http-xhrio {:method :post
                  :uri (str "/api/questionnaires/" questionnaire "/sheet/" sheet "/import-questions")
                  :params parsing-config
                  :format http-config/transit-request-format
                  :response-format http-config/transit-response-format
                  :on-success [::import-success questionnaire sheet on-save]
                  :on-failure [::ui/set-error]}}))

(defn modal-save-extraction-results [on-save {:keys [on-close]}]
  (let [{:keys [parsing-config
                questionnaire
                sheet]} @(rf/subscribe [::subs/workbook-workspace.active-workbook])
        parsing-results @(rf/subscribe [::subs/workbook-workspace.results])
        errors (keep (fn [result]
                       (let [row-errors (cond-> []
                                          (str/blank? (-> result :content :content))
                                          (conj (str "Empty question content")))]
                         (when (seq row-errors)
                           {:row-index (-> result :row-index)
                            :row-errors row-errors})))
                     parsing-results)
        errors? (seq errors)]
    [:div.card
     [:div.p-4
      [:div [:p.title.is-5 "Save Questionnaire Extraction Results"]
       (if errors?
         [:<>
          [:p.subtitle.is-5 "Found " (count errors) " errornous rows"]
          [:div.notification.is-light.is-danger
           [:ul
            (map (fn [{:keys [row-errors row-index]}]
                   [:li {:key row-index}
                    (str "Row " row-index " (Excel index " (dec row-index) ")")
                    [:ul.ml-2
                     (map-indexed (fn [index error]
                                    [:li {:key (str row-index "-" index)} error])
                                  row-errors)]])
                 errors)]]]
         [:<>
          [:div.notification
           [:p.subtitle.is-5 "Identified " (count parsing-results) " questions"]
           [:p "Importing the questions from the workbook sheet is a one-time action, and questions cannot be added or removed later."]]])

       [:div.level
        [:button.button.is-danger
         {:on-click on-close} "Cancel"]
        [:button.button.is-success
         {:disabled errors?
          :on-click (fn [_]
                      (rf/dispatch [::import-questions questionnaire sheet parsing-config on-save])
                      (on-close))}
         "Import into Questionnaires"]]]]]))
